import { Injectable } from '@angular/core';
import { environment } from '../environment';
import AlertifyHelper from './utils';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {
  constructor(private alertifyMsg: AlertifyHelper) {}

  searchArrById(id: any, array_: any) {
    // let data = array_;
    let response = [];
    for (let i = 0; i < array_.length; i++) {
      let temp_data = array_[i];
      if (temp_data['id'] == id) {
        response.push(temp_data);
        break;
      }
    }
    return response[0];
  }

  searchObjById(id: any, array_: any) {
    // let data = array_;
    let response = [];
    for (let i = 0; i < array_.length; i++) {
      let temp_data = array_[i];
      if (temp_data.id == id) {
        response.push(temp_data);
        break;
      }
    }
    return response[0];
  }

  searchObjByKey(key: any, array_: any) {
    // let data = array_;
    let response = [];
    for (let i = 0; i < array_.length; i++) {
      let temp_data = array_[i];
      if (temp_data.key == key) {
        response.push(temp_data);
        break;
      }
    }
    return response[0];
  }

  notExistObjInArr(obj: any, array_: any) {
    let is_unique = true;
    for (let i = 0; i < array_.length; i++) {
      let temp_data = array_[i];
      if (temp_data.id == obj.id) {
        is_unique = false;
        break;
      }
    }
    return is_unique;
  }

  isStringContainsIframe(inputString: any) {
    // Regular expression to match iframe tag
    const iframeRegex = /<iframe.*?<\/iframe>/i;
    // Test if the input string contains an iframe tag
    return iframeRegex.test(inputString);
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 1024 * 1024; // 1MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_img) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        if (isMulti) {
          _txt = 'Uno de los archivos seleccionados (' + file.name + ')';
        }
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (0.5 MB -> 500 kb). Elija un archivo más pequeño.',
          5
        );
        return false;
      }
    }

    return true;
  }

  momeySol() {
    return 'S/ ';
  }

  strToNull(val: any) {
    let str_ = val;
    if (val == 'null') {
      str_ = null;
    }
    return str_;
  }

}
